import { Button, Container, Group, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

import classes from "./NotFound.module.scss";

interface Props {
  message?: string;
}

function NotAuthorized({ message }: Props) {
  return (
    <Container className={classes.root}>
      <div className={classes.label}>403</div>
      <Title className={classes.title}>Not authorized</Title>
      <Text
        c="dimmed"
        size="lg"
        ta="center"
        className={classes.description}>
        {message ??
          "You do not have permission to view this page. Contact your administrator if you believe this is an error."}
      </Text>
      <Group justify="center">
        <Button component={Link} to="/home" variant="subtle" size="md">
          Back to home page
        </Button>
      </Group>
    </Container>
  );
}

export default NotAuthorized;
